import React from "react";
import { PackingListSecondItemModel } from "../../domain/models/packingListModel";
import LicensePlate from "license-plate";
import licencePlateSelectBg from "../../../../general/fields/modules/commons/licencePlateSelectField/assets/licencePlateSelectBg.svg";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { CheckCircleFill } from "react-bootstrap-icons";
interface RequestsCardProps {
  secondItem: PackingListSecondItemModel;
}

export const RequestsCard = ({ secondItem }: RequestsCardProps) => {
  const { t } = useTranslation("common");

  return (
    <div className={"content me-2 py-3 px-2"}>
      <div className={"content-header"}>
        {secondItem.requests.every((request) => request.finalized) && (
          <div className={"me-2"}>
            <CheckCircleFill style={{ color: "#23be55" }} />
          </div>
        )}

        <h3>{secondItem.source?.label}</h3>
      </div>
      <div>
        {secondItem.requests.map((request) => {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          const plate = new LicensePlate(request.source?.car?.licence ?? "");
          return (
            <div className={"mt-2"} key={request.id}>
              <div className={"d-flex"}>
                <Link
                  to={"/requests/" + request.id}
                  className={"no-link-decoration"}
                >
                  {plate.valid() ? (
                    <div
                      className={"tireset-table-licence-plate me-2"}
                      style={{
                        background: `url(${licencePlateSelectBg}) no-repeat center center / cover`,
                      }}
                    >
                      <div>{plate.pretty()}</div>
                    </div>
                  ) : (
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    (request.source?.car?.licence ?? request.source?.car?.label)
                  )}
                </Link>

                <span
                  className={
                    "fw-bold badge bg-" +
                    (request.finalized ? "success" : "danger")
                  }
                >
                  {t(request.state ?? "")}
                </span>
              </div>

              <div>
                {/*eslint-disable-next-line @typescript-eslint/ban-ts-comment*/}
                {/*@ts-ignore*/}
                {request.source?.position?.label && (
                  <span className={"small fw-bold me-2"}>
                    {/*eslint-disable-next-line @typescript-eslint/ban-ts-comment*/}
                    {/*@ts-ignore*/}
                    {request.source?.position?.label}
                  </span>
                )}

                <span className={"small"}>{request?.relation?.name}</span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
